import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import { deleteError } from "@/redux/modules/value/errors/errors.module";
import { getErrors } from "@/redux/modules/value/errors/errors.selectors";

import ErrorMessage from "./errorMessages.component";

const ErrorMessages = () => {
    const dispatch = useThunkDispatch();
    const errors = useSelector(getErrors);

    const handleDelete = (err: any) => {
        dispatch(deleteError(err));
    };

    return (
        <>
            {errors?.map((err, index) => (
                <ErrorMessage
                    key={index}
                    message={err.message}
                    handleDelete={() => {
                        handleDelete(err);
                    }}
                />
            ))}
        </>
    );
};

export { ErrorMessages };
